<template lang="pug">
  v-card.calendar-list-item-type(tile flat)
    v-layout( v-if="item" :class="getStatusClass(item)")
      v-flex.type_label( disabled v-if="getGroupLabel") {{label}}
      v-icon.type_icon( class="fas fa-check" v-if="isMenuGroupOffered(item)" small color="green")
      v-icon.type_icon( class="fas fa-exclamation" v-else small color="gray")
      v-icon.next-icon.pl-2(class="fas fa-chevron-double-right" color="primary" small)
    v-layout( v-else :class="getEventClass()" )
      v-flex.type_label {{eventName}}

</template>

<script lang="ts">
import Vue from 'vue'
import MenuGroupItem from "@/model/dailymenu/MenuGroupItem";
import {Component, Prop} from "vue-property-decorator";

@Component({
  components: {

  }
})
export default class CalendarListItemType extends Vue {

  @Prop({type: Object as () => MenuGroupItem}) item!: MenuGroupItem
  @Prop({type: [Number]}) countItems!: number
  @Prop({type: String}) eventName!: string

  private types: any | undefined = undefined
  private isNotSelectedFlag: string = ""
  private label: string = ""
  private isNotSelected: boolean = true

  getGroupLabel(): boolean | undefined {
    const groups = this.countItems
    const subGroups = this.item.subGroupList.length

    if (subGroups == 0)
      return false
    else if (subGroups != 1 && groups == 1)
      return false
    else if (subGroups != 1)
      return true

  }

  isMenuGroupOffered(item: MenuGroupItem): boolean {
    return item.isMenuGroupOffered
  }

  getStatusClass(item: MenuGroupItem): string {
    const status = this.isMenuGroupOffered(item)
    return status ? "filled" : "notfilled"
  }

  getEventClass(): string {
    if (this.eventName == 'Prázdniny') {
      return 'yellow'
    } else if (this.eventName == 'Voľný deň') {
      return 'orange'
    }

    return ''
  }

  mounted(): void {

    if (this.item) {
      this.label = this.item.title

      if (this.item.subGroupList.length == 0) {
        this.isNotSelected = true
      } else {
        this.isNotSelected = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>

.calendar-list-item-type
  font-size 1em
  margin 5px 0
  border-radius 0 !important

.filled
  background-color #c8e6c9
  padding 0 4px

.notfilled
  background-color rgba(0, 0, 0, .08)
  padding 0 4px

.type_label
  font-size 0.7em
  text-align left

.orange
  background-color orange

.yellow
  background-color yellow

.group
  flex-direction row
  display flex

  .group-item
    margin: 0 10px

    .group_title
      font-size 0.6em
      padding 10px 0


</style>
